module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": "",
      "md4": "",
      "offset-md4": ""
    }
  }, [_c('div', {
    staticClass: "my-5 display-1"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.success) ? [_c('p', {
    staticClass: "body-2"
  }, [_vm._v("Uspešno ste potvrdili Vašu email adresu. Potrebno je da Vaš nalog potvrdi i administrator.")]), _vm._v(" "), _c('p', {
    staticClass: "body-2"
  }, [_vm._v("Molimo Vas pošaljite nam podatke osobe za kontakt na "), _c('a', {
    attrs: {
      "href": "mailto:miljan@lanser.rs"
    }
  }, [_vm._v("miljan@lanser.rs")]), _vm._v(" ili nas kontaktirajte na broj telefona +381658175678 kako bismo uzeli Vaše podatke. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-2"
  }, [_vm._v("Ovaj korak je neophodan kako bismo zadržali pouzdanost servisa.")])] : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 2)], 1)], 1)
},staticRenderFns: []}